document.addEventListener("DOMContentLoaded", function() {

    const survey = new Survey.Model(surveyJson);

    survey.locale = currentLanguage;

    survey.onStarted.add(function (sender) {
        //console.log("Quiz STARTED at: ", new Date());
         
        fetch('/survey-response/' + responseUuid + '/update-start-time', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({
                started_at: new Date().toISOString()
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                console.log('Survey start time updated successfully');
            } else {
                console.error('Failed to update survey start time:', data.message);
            }
        })
        .catch(error => {
            console.error('Error updating survey start time:', error);
        });
    });
    
    if (typeof surveyResponse !== 'undefined' && surveyResponse !== null) {
        survey.data = surveyResponse;  
    }    
 
    const savedTimeSpent = localStorage.getItem('survey_timer_' + responseUuid); 
    if (savedTimeSpent !== null) {
        survey.timeSpent = parseInt(savedTimeSpent, 10);
    }

    survey.mode = surveyMode;
    if (surveyMode === 'display') {
        survey.questionsOnPageMode = "singlePage";
        const correctStr = "Correct";
        const incorrectStr = "Incorrect";
        
        function getTextHtml (text, str, isCorrect) {
            if (text.indexOf(str) < 0)
                return undefined;
            return text.substring(0, text.indexOf(str)) +
                "<span class='" +  (isCorrect ? "correctAnswer" : "incorrectAnswer" ) + "'>" +
                    str +
                "</span>";
        }
        
        function changeTitle (q) {
            if (!q) return;
            if (!q.correctAnswer) return;
            const isCorrect = q.isAnswerCorrect();
            if (!q.prevTitle) {
                q.prevTitle = q.title;
            }
            if (isCorrect === undefined) {
                q.title = q.prevTitle;
            }
            q.title =  q.prevTitle + ' ' + (isCorrect ? correctStr : incorrectStr);
        }

        survey.onAfterRenderQuestion.add((survey, options) => {
            const question = options.question;
    
            if (!question.correctAnswer) return;
    
            if (!question.isAnswerCorrect()) {
                options.htmlElement.querySelectorAll('.sd-item__control-label').forEach((label, index) => {
                    const choice = question.visibleChoices[index];
                    if (choice.value === question.correctAnswer) {
                        label.classList.add('highlight-correct'); 
                    }
                });
            }
        });
    

        survey.onTextMarkdown.add((_, options) => {
            
            const text = options.text;
            let html = getTextHtml(text, correctStr, true);
            if (!html) {
                html = getTextHtml(text, incorrectStr, false);
            }
            if (!!html) {
                // Set an HTML string with the "Correct" or "Incorrect" suffix for display
                options.html = html;
            }
        });
        // Indicate correct and incorrect answers at startup
        survey.getAllQuestions().forEach(question => changeTitle(question)); 
        setTimeout(waitForSvgContainerAndRender, 50);
    } 
         
    survey.onTimer.add((sender) => {
        const timeLeft = sender.maxTimeToFinish - sender.timeSpent;
        //console.log("Time left:", timeLeft);

        localStorage.setItem('survey_timer_' + responseUuid, sender.timeSpent);
 
        if (timeLeft <= 3) {
            sender.timerModel.stop();
 
            Swal.fire({
                title: surveyTimeUpTitle,
                text: surveyTimeUpMessage,
                icon: 'info',
                confirmButtonText: 'OK'
            });
        }
    });
     
    survey.onValueChanged.add(function(sender, options) {
        fetch('/survey-response/' + responseUuid + '/save-progress', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({
                results: sender.data
            })
        })
        .then(response => {
            if (response.ok) {
                console.log('Progress saved successfully.');
            } else {
                console.log('Error saving progress.');
            }
        })
        .catch(error => {
            console.log('Error saving progress.');
        });
    });

    survey.onComplete.add(function (sender) {
        fetch('/survey-response/' + responseUuid + '/submit', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({
                results: sender.data
            })
        })
        .then(response => {
            if (response.ok) {
                Swal.fire({
                    title: 'Submitted',
                    text: 'Your responses have been successfully submitted.',
                    icon: 'success',
                    confirmButtonText: 'OK'
                });
                localStorage.removeItem('survey_timer_' + responseUuid);
    
                const reloadPageBtn = document.getElementById('reloadPageBtn');
                if (reloadPageBtn) {
                    reloadPageBtn.addEventListener('click', function () {
                        window.location.reload();
                    });
                }
            } else {
                return response.text().then(text => {
                    throw new Error(text);
                });
            }
        })
        .catch(error => {
            Swal.fire({
                title: 'Submission Error',
                text: 'There was an error submitting your survey: ' + error.message,
                icon: 'error',
                confirmButtonText: 'OK'
            });
        });
    });

    survey.onAfterRenderPage.add(function (sender, options) {
        if (options.page.name === "result_ma_page") { 
    
            setTimeout(() => {
                const p = sender.data.p_average ?? 0;
                const o = sender.data.o_average ?? 0;
                const t = sender.data.t_average ?? 0;
                const d = sender.data.d_average ?? 0;
    
                //console.log("Values at SVG render time:", { p, o, t, d });
    
                const maturityString = `P${p.toFixed(1)}-O${o.toFixed(1)}-T${t.toFixed(1)}-D${d.toFixed(1)}`;
                //console.log("Rendering SVG with string:", maturityString);
    
                drawRatingBox(maturityString, true);
            }, 50);  
        }
    }); 
    
    function drawRatingBox(maturityString, directInsert = false) {
        if (!maturityString || typeof maturityString !== "string") {
            console.error("maturityString is invalid:", maturityString);
            return;
        }
    
        const translations = {
            "en": ['People', 'Operations', 'Technology', 'Data'],
            "es": ['Personas', 'Operaciones', 'Tecnología', 'Datos'],
            "pt-br": ['Pessoas', 'Operações', 'Tecnologia', 'Dados'],
        };
        
        const categories = translations[currentLanguage.toLowerCase()] || translations["en"];
        const levels = maturityString.split('-').map(s => parseFloat(s.slice(1)));
        let svg = `<svg width="160" height="100" style="font-size:12px">
            <rect x="0" y="0" rx="4" ry="4" width="160" height="100" style="fill:#ffff;stroke:#dedede;stroke-width:3.4;" />`;
    
        let tooltipContent = [];
    
        for (let i = 0; i < categories.length; i++) {
            const y = 23 + i * 17;
            svg += `<text x="6" y="${y}">${categories[i]}:</text>`;
            tooltipContent.push(`${categories[i]}: ${levels[i]}`); 
    
            for (let j = 0; j < 4; j++) {
                const x = 76 + j * 17;  
                const fill = j < Math.floor(levels[i]) ? '#f0a700' : (j < levels[i] ? '#f0a700' : '#dedede');
                svg += `<rect x="${x}" y="${y - 11}" width="16" height="16" fill="${fill}"></rect>`;
                if (j === Math.floor(levels[i]) && levels[i] % 1 > 0) {
                    const partialFillWidth = 16 * (levels[i] % 1);
                    svg += `<rect x="${x}" y="${y - 11}" width="${partialFillWidth}" height="16" fill="#f0a700"></rect>`;
                    svg += `<rect x="${x + partialFillWidth}" y="${y - 11}" width="${16 - partialFillWidth}" height="16" fill="#dedede"></rect>`;
                }
            }
        }
    
        if (directInsert) { 
            document.getElementById('svg-container').innerHTML = svg;
             
            var tooltipElement = document.getElementById('svg-container');
            if (bootstrap.Tooltip.getInstance(tooltipElement)) {
                bootstrap.Tooltip.getInstance(tooltipElement).dispose();
            }
            new bootstrap.Tooltip(tooltipElement, {
                title: tooltipContent.join('<br>'),
                html: true,
                placement: 'right' 
            });
        } else { 
            return svg;
        }
    }

    survey.render(document.getElementById("surveyContainer"));
 
    addLocaleDropdown();
 
    function addLocaleDropdown() {
        const availableLocales = [];
        const surveyLocales = survey.getUsedLocales();
        const localeNames = Survey.surveyLocalization.localeNames;
     
        surveyLocales.forEach((localeCode) => {
            availableLocales.push({
                value: localeCode,
                text: localeNames[localeCode] || localeCode
            });
        });
     
        if (availableLocales.length <= 1) {
            return;
        }

        let selectedLocale = survey.locale || "";
     
        const handleLocaleChange = (event) => {
            selectedLocale = event.target.value;
            survey.locale = selectedLocale;
        };
     
        const localeDropdown = document.createElement('div');
        localeDropdown.classList.add('locale-dropdown-wrapper', 'language-dropdown-custom'); 
        localeDropdown.innerHTML = `
            <select class="sd-input sd-dropdown sd-dropdown--empty" id="localeSelector">
                <option value="">Select a locale</option>
                ${availableLocales.map(locale => `
                    <option value="${locale.value}">
                        ${locale.text.charAt(0).toUpperCase() + locale.text.slice(1)}
                    </option>
                `).join('')}
            </select>
        `;
     
        localeDropdown.querySelector('#localeSelector').value = selectedLocale;
     
        localeDropdown.querySelector('#localeSelector').addEventListener('change', handleLocaleChange);
     
        const container = document.getElementById('localeDropdownContainer');
        container.appendChild(localeDropdown);
    } 

    function waitForSvgContainerAndRender() {         
        // Fallback interval approach only - simpler and more reliable
        let attempts = 0;
        const checkInterval = setInterval(function() {
            attempts++;
            const container = document.getElementById('svg-container');
            
            if (container) {
                clearInterval(checkInterval);
                //console.log("Container found after", attempts, "attempts");
                
                // Use original function
                const p = survey.data.p_average ?? 0;
                const o = survey.data.o_average ?? 0;
                const t = survey.data.t_average ?? 0;
                const d = survey.data.d_average ?? 0;
                
                const maturityString = `P${p.toFixed(1)}-O${o.toFixed(1)}-T${t.toFixed(1)}-D${d.toFixed(1)}`;
                //console.log("Rendering SVG with string:", maturityString);
                
                drawRatingBox(maturityString, true);
            } else if (attempts >= 5) {
                clearInterval(checkInterval);
                //console.warn("Giving up after 20 attempts");
            }
        }, 100); // Check every 100ms
    }
});

function adjustDivHeight() {
    var navbarHeight = 68;
    var footerHeight = 39;
    var availableHeight = window.innerHeight - navbarHeight - footerHeight;
    document.getElementById('survey').style.minHeight = availableHeight + 'px';
}
window.onload = adjustDivHeight;
window.onresize = adjustDivHeight;
